import { Button, Col, Divider, Form, Row } from "antd";
import { useNotaListar } from "../../../../../Services/Financeiro/Titulo/NotaService";
import NotaTable from "./NotaTable";
import { Nota } from "../../../../../Models/Financeiro/Titulo/Nota";
import { useEffect, useState } from "react";
import dayjs from 'dayjs';
import NotaSituacaoSelect from "./NotaSituacao/NotaSituacaoSelect";
import PessoaSelectComTipo from "../../../Pessoa/PessoaSelect";
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import { PermissoesKey } from "../../../../../Constants/Permissoes";
import NotaFormModal from "./NotaFormModal";
import InputDate from "../../../../Base/Input/InputDate";

export interface INotaConsultaScreenProps
{

}

type FormType = {
    nota?:Nota;
    dataCompetenciaInical?:dayjs.Dayjs;
    dataCompetenciaFinal?:dayjs.Dayjs;
}
export default function NotaConsultaScreen ({
    ...rest
}:INotaConsultaScreenProps) {
    const dataAtual = new Date();

    const [ listar, setListar ] = useState(true);
    const [ form ] = Form.useForm();
    
    const nota = Form.useWatch<Nota|undefined>("nota", form);
    const dataCompetenciaInical = Form.useWatch<dayjs.Dayjs|undefined>("dataCompetenciaInical", form);
    const dataCompetenciaFinal = Form.useWatch<dayjs.Dayjs|undefined>("dataCompetenciaFinal", form);
    
    const {
        data,
        isLoading
    } = useNotaListar({
        enabled : listar,
        nota,
        dataCompetenciaInical,
        dataCompetenciaFinal,
        ativo : true,
        onFinish() {
            setListar(false);
        },
    });

    return <Form<FormType>
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={() => {
            setListar(true);
        }}
        initialValues={{
            dataCompetenciaInical : dayjs(new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1)),
            dataCompetenciaFinal : dayjs(new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0)),
            nota : undefined
        } as FormType}
    >
        <Row gutter={8} wrap>
            <Col xs={12}>
                <PessoaSelectComTipo<FormType>
                    placeholder="Beneficiário" 
                    placeholderTipo="Tipo beneficiário"
                    names={{
                        "*"  : [ "nota", "titulo", "codBeneficiario" ],
                        tipo : [ "nota", "titulo", "beneficiario", "tipo"]
                    }}
                />
            </Col>
            <Col xs={12}>
                <PessoaSelectComTipo<FormType>
                    placeholder="Devedor" 
                    placeholderTipo="Tipo devedor"
                    names={{
                        "*"  : [ "nota", "titulo", "codDevedor" ],
                        tipo : [ "nota", "titulo", "devedor", "tipo"]
                    }}
                />
            </Col>
            <Col xs={24} sm={12} md={8} lg={5}>
                <Form.Item<FormType> 
                    label="Competência inicial" 
                    name={"dataCompetenciaInical"} 
                    rules={[ { required : true } ]}
                >
                    <InputDate />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={5}>
                <Form.Item<FormType> 
                    label="Competência final" 
                    name={"dataCompetenciaFinal"} 
                    rules={[ { required : true } ]}
                >
                    <InputDate />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={5}>
                <Form.Item<FormType> 
                    label="Situação" 
                    name={["nota", "codSituacao"]} 
                    rules={[ { required : false } ]}
                >
                    <NotaSituacaoSelect />
                </Form.Item>
            </Col>
        </Row>
        <Row gutter={8} wrap>
            <Col xs={"auto"}>
                <Button type="primary" htmlType="submit">
                    Listar
                </Button>
            </Col>
            <Col>
                <NotaFormModal 
                    nota={{} as Nota} 
                    textButtonOpen={"Adicionar"} 
                    propsButtonOpen={{ size : "middle" }} 
                    onSuccess={() => {
                        setListar(true);
                    }}
                />
            </Col>
        </Row>
        <Divider>Registros</Divider>
        <ComponentePermissao permissoes={["FinanceiroTituloNotaListar"]}>
            <NotaTable
                isGerar
                isCancelar
                loading={isLoading}
                dataSource={data}
                onReFetch={() => setListar(true)}
            />
        </ComponentePermissao>
    </Form>
}